/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401,
  PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1IndividualpaymentParcelsParcelidInvoiceUploadUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/invoice-upload` as const,
  };
  return res;
}

/**
 * @description Aceita pdf/png/jpg/jpeg/bmp/tiff/tif; bloqueia se já há NFe em processamento; salva no armazenamento e vincula à parcela. Migrado do legado IndividualPayment/UploadInvoice. **(Requer Authorization para autenticação)**
 * @summary Anexa o arquivo da nota fiscal à parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/invoice-upload}
 */
export async function postApiV1IndividualpaymentParcelsParcelidInvoiceUpload(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadPathParams["parcelId"],
  data?: PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload400
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload401
      | PostApiV1IndividualpaymentParcelsParcelidInvoiceUpload500
    >,
    PostApiV1IndividualpaymentParcelsParcelidInvoiceUploadMutationRequest
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidInvoiceUploadUrl(
      parcelId,
    ).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
